import Layout from "../../layout";
import HomeF1 from "../../components/Home/HomeF1";
import HomeF2 from "../../components/Home/HomeF2";
import HomeF3 from "../../components/Home/HomeF3";
import HomeF4 from "../../components/Home/HomeF4";
import HomeF6 from "../../components/Home/HomeF6";
import HomeF7 from "../../components/Home/HomeF7";
import { useSeo } from "../../utils/seo";

// Homepage — STATIC, code-managed (migrated off Contentful). Content and design
// are maintained here in code, matching the rest of the site's landing pages.
// Section order: hero -> intro band -> 5 product spotlights -> solutions grid ->
// why choose -> customer-reviews closing CTA band.

const META_TITLE = "Affordable Insurance in California | GM Insurance Services";
const META_DESCRIPTION =
    "Compare affordable insurance quotes in California for auto, home, earthquake, business, commercial auto, trucking, general liability, and workers' compensation.";

export default function Home() {
    useSeo({ title: META_TITLE, description: META_DESCRIPTION, path: "/" });

    return (
        <Layout full>
            <HomeF1 />
            <HomeF2 />
            <HomeF3 />
            <HomeF4 />
            <HomeF6 />
            <HomeF7 />
        </Layout>
    );
}
